/* DO NOT EDIT!
   This file is generated from: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/absdk/portal/portals/platform/client/src/main/localeProperties/platform_en.properties
   To regenerate after edits to the above file, invoke the module's package.json task: locale:regen:maven
   Also helpful: https://confluence.abinitio.com/display/FED/Localization+for+Developers
*/

// eslint-disable
import {AbWebServices} from "abweb/service/AbWebServices";

/**
 * <pre>
 * personas.dataAnalyst.description=Produce insights & create metrics
 * </pre>
 */
export function personas_dataAnalyst_description(): string
{
  return AbWebServices.i18n.getMessage("platform", "personas.dataAnalyst.description");
}

/**
 * <pre>
 * personas.dataAnalyst.name=Data Analyst
 * </pre>
 */
export function personas_dataAnalyst_name(): string
{
  return AbWebServices.i18n.getMessage("platform", "personas.dataAnalyst.name");
}

/**
 * <pre>
 * personas.dataEngineer.description=Implement data infrastructure
 * </pre>
 */
export function personas_dataEngineer_description(): string
{
  return AbWebServices.i18n.getMessage("platform", "personas.dataEngineer.description");
}

/**
 * <pre>
 * personas.dataEngineer.name=Data Engineer
 * </pre>
 */
export function personas_dataEngineer_name(): string
{
  return AbWebServices.i18n.getMessage("platform", "personas.dataEngineer.name");
}

/**
 * <pre>
 * startup.unavailableServer.body=Try refreshing your browser or contact your administrator
 * </pre>
 */
export function startup_unavailableServer_body(): string
{
  return AbWebServices.i18n.getMessage("platform", "startup.unavailableServer.body");
}

/**
 * <pre>
 * #{0} - Name of the Ab Initio product
 * startup.unavailableServer.message=The application could not connect to {0}
 * </pre>
 */
export function startup_unavailableServer_message(arg0: string): string
{
  return AbWebServices.i18n.getMessage("platform", "startup.unavailableServer.message", arg0);
}

/**
 * <pre>
 * startup.unavailableServer.title=Server Unavailable
 * </pre>
 */
export function startup_unavailableServer_title(): string
{
  return AbWebServices.i18n.getMessage("platform", "startup.unavailableServer.title");
}

/**
 * <pre>
 * startup.waitingForAG=Starting authentication services
 * </pre>
 */
export function startup_waitingForAG(): string
{
  return AbWebServices.i18n.getMessage("platform", "startup.waitingForAG");
}

/**
 * <pre>
 * startup.waitingForApplicationServices=Starting application services
 * </pre>
 */
export function startup_waitingForApplicationServices(): string
{
  return AbWebServices.i18n.getMessage("platform", "startup.waitingForApplicationServices");
}

